<template>
    <div class="context">
        <div class="header">
            <el-page-header @back="back" :content="viewTitle">
            </el-page-header>
        </div>

        <div>
            <el-form :model="dialog_form"
                     :rules="rules"
                     ref="dialog_form"
                     label-width="100px">
                <el-form-item label="标题：" prop="title">
                    <el-input v-model="dialog_form.title"
                              clearable
                              class="width_800"></el-input>
                </el-form-item>
                <el-form-item label="摘要：">
                    <el-input v-model="dialog_form.abstract"
                              clearable
                              type="textarea"
                              :rows="2"
                              class="width_800"></el-input>
                </el-form-item>
                <el-form-item label="内容：" prop="content">
                    <el-input v-model="dialog_form.content"
                              clearable
                              type="textarea"
                              :rows="4"
                              class="width_800"></el-input>
                </el-form-item>
                <el-form-item label="备注：">
                    <el-input v-model="dialog_form.remark"
                              clearable
                              type="textarea"
                              :rows="4"
                              class="width_800"></el-input>
                </el-form-item>
                <el-form-item>
                    <el-button @click="back()">取 消</el-button>
                    <el-button type="primary" @click="submit_dialog()">确 定</el-button>
                </el-form-item>
            </el-form>
        </div>
    </div>
</template>

<script>
    import {mapState} from "vuex"
    import {clone} from "@/global/utils";

    export default {
        name: "add",
        data() {
            return {
                viewTitle: '新增问候语',

                dialog_form: {
                    title: '',
                    abstract: '',
                    content: '',
                    remark: '',
                },
                rules: {
                    title: [{required: true, message: '请输入标题',trigger: 'blur'}],
                    abstract: [{required: true, message: '请输入摘要',trigger: 'blur'}],
                    content: [{required: true, message: '请输入内容',trigger: 'blur'}],
                },
            }
        },
        computed: {
            ...mapState("questionData", {
                warnings: 'warnings'
            })
        },
        mounted() {
            if (this.warnings.title) {
                this.viewTitle = this.warnings.title;
                this.dialog_form = clone(this.warnings.form);
            }
        },
        methods: {
            back() {
                this.$emit('changeTopTab', 'tableView')
            },
            submit_dialog() {
                this.$refs.dialog_form.validate((valid) => {
                    if (valid) {
                        let params = {
                            ...this.dialog_form
                        };
                        params.wtype = 'G_REMIND';
                        this.httpPost('/wording/save', params).then(res => {
                            this.$message.success('保存成功');
                            this.back()
                        })
                    }
                })
            }
        }
    }
</script>

<style scoped lang="scss">
    .context {
        width: 100%;
        height: 100%;
        background: #fff;
        .header {
            height: 45px;
            padding: 10px;
        }
    }
</style>